import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * La raíz lleva al tablero. Hasta que E34 existió, llevaba al catálogo del
 * sistema de diseño; ahora hay pantalla a la que entrar.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/inicio' })
  },
})
